import { StackablePageButtons, PageSection } from '@product-framework/index';
import ServiceAreaMap, {
  METERS_PER_STATUTE_MILE,
} from '@product-framework/components/ServiceAreaMap';
import { useLocalization } from '@ui-framework/index';
import { useNavigate } from 'react-router-dom';
import { withServiceProvider } from '../../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../../utils/getSPLevelStackableButtons';
import {
  useServiceProviderLocation,
  withServiceProviderLocation,
} from '../../../../../../providers/ServiceProviderLocationProvider';

function ServiceArea() {
  const { formatMessage } = useLocalization();
  const { spLocation } = useServiceProviderLocation();
  const navigate = useNavigate();

  const stackablePageButtons = [];
  const defaultLocation = {
    lat: 39.043,
    lng: -77.487,
  };
  /** Same coverage as previous 2000 m default (~1.24 statute mi). */
  const radiusMiles = 2000 / METERS_PER_STATUTE_MILE;

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_SERVICEAREA"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        containerProps={{ sx: { mb: 3 } }}
        HeaderContent={
          <StackablePageButtons
            backButton={false}
            buttons={stackablePageButtons}
          />
        }
        label={formatMessage(
          {
            id: 'EDIT_LOCATION_LOCATIONNAME',
            defaultMessage: 'Edit Location - {locationName}',
          },
          {
            locationName: spLocation?.locationName,
          },
        )}>
        <ServiceAreaMap
          centerPoint={defaultLocation}
          radiusMiles={radiusMiles}
          zones={null}
          height={680}
          zoom={6}
          onChange={data => {
            // eslint-disable-next-line no-console
            console.log(data);
          }}
          onSaveChanges={data => {
            // eslint-disable-next-line no-console
            console.log(data);
          }}
          bulkImportCountryCode="US"
        />
      </PageSection>
    </ServiceProviderLayout>
  );
}

export default withServiceProvider(withServiceProviderLocation(ServiceArea));
